import React from "react";
import AnchorLink from "react-anchor-link-smooth-scroll";
import profFirst from "../../assets/profFirst.webp";
import landscape6 from "../../assets/landscape6.webp";
import { MotionItem, MotionSection, MotionStagger, MotionHover } from "../../motion/primitives";

const Hero = () => {
  return (
    <MotionSection
      id="home"
      className="relative w-full max-w-none mx-auto overflow-hidden"
    >
      {/* Full-bleed banner background */}
      <div className="absolute inset-0">
        <img
          src={landscape6}
          alt=""
          loading="eager"
          fetchpriority="high"
          className="h-full w-full object-cover object-center scale-[1.02]"
        />
        <div className="absolute inset-0 bg-black/55" />
        <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,rgba(255,255,255,0.08),rgba(0,0,0,0.75))]" />
        <div className="absolute inset-x-0 bottom-0 h-40 bg-gradient-to-t from-[#161513] to-transparent" />
      </div>

      <MotionStagger className="relative z-10 w-full max-w-[1200px] mx-auto flex flex-col items-center gap-10 px-4 pt-14 sm:pt-16 md:pt-20">
        <MotionItem y={22}>
          <MotionHover className="will-change-transform" scale={1.02}>
            <img
              src={profFirst}
              alt=""
              className="mt-6 w-[200px] aspect-square rounded-[28px] object-cover border border-white/20
              shadow-[0_25px_80px_rgba(0,0,0,0.45)]
              sm:w-[260px] md:w-[380px] md:mt-[70px]"
            />
          </MotionHover>
        </MotionItem>

        <MotionItem className="w-full">
          <div className="w-full flex flex-col items-center gap-4">
            <p className="w-full text-center mx-auto text-[12px] tracking-[0.28em] uppercase text-white/60">
              Freelance photographer · Cumbria
            </p>
            <h1 className="text-center w-full font-semibold leading-[1.05] flex flex-col items-center gap-3">
              <span className="text-[34px] sm:text-[44px] md:text-[78px]">
                The{" "}
                <span className="bg-gradient-to-r from-[#df8908] via-[#e98a2f] to-[#f6b14d] bg-clip-text text-transparent">
                  Solitary
                </span>{" "}
                Photographer
              </span>
              <span className="text-[16px] sm:text-[20px] md:text-[28px] text-white/80 font-medium max-w-[42ch] mx-auto text-center">
                Landscape, event, and action photography—crafted with an editorial eye.
              </span>
            </h1>
          </div>
        </MotionItem>

        <MotionItem className="w-full flex justify-center">
          <p
            className="w-full px-4 sm:px-0 max-w-[62ch] mx-auto text-center text-[14px] leading-[28px] text-white/80
            sm:text-[16px] md:text-[18px] md:leading-[34px]"
          >
            I'm James Critchley, a freelance photographer living in Cumbria, where
            the breath-taking scenery inspires much of my work.
          </p>
        </MotionItem>

        <MotionItem>
          <div
            className="flex flex-col w-full gap-4 items-center mb-8 text-[16px]
            sm:text-[18px] md:flex-row md:justify-center md:gap-4 md:mb-14"
          >
            <div className="w-[70%] md:w-auto">
              <MotionHover scale={1.02}>
                <div
                  className="font-display w-full px-5 py-3 rounded-full bg-gradient-to-r from-[#df8908] via-[#e98a2f] to-[#f6b14d] 
                  cursor-pointer text-center border border-white/10
                  shadow-[0_12px_40px_rgba(246,177,77,0.16)]
                  sm:px-7 sm:py-3.5"
                >
                  <AnchorLink
                    className="no-underline text-white"
                    offset={50}
                    href="#contact"
                  >
                    Enquire / Book
                  </AnchorLink>
                </div>
              </MotionHover>
            </div>

            <div className="w-[70%] md:w-auto">
              <MotionHover scale={1.02}>
                <div
                  className="font-display w-full px-5 py-3 rounded-full border border-white/20 bg-white/5
                  cursor-pointer hover:border-white/40 text-center
                  sm:px-7 sm:py-3.5"
                >
                  <AnchorLink
                    className="no-underline text-white"
                    offset={50}
                    href="#gallery"
                  >
                    View portfolio
                  </AnchorLink>
                </div>
              </MotionHover>
            </div>
          </div>
        </MotionItem>
      </MotionStagger>
    </MotionSection>
  );
};

export default Hero;
